module.exports = __webpack_public_path__ + "school/img/youeryuanJc.076d80d1.jpg";